import {SelectWrapper} from "Components/Common/SelectWrapper";
import * as React from "react";
import {useUsers, User} from "@/hooks/user";
import {useEffect, useState} from "react";

interface UserSelectorProps {
    isMulti?: boolean
    isDisabled?: boolean
    onChange?: (users: string[]) => void
    selectedUsers: string[]
    schoolId?: string
}
export default function UserSelector(props: UserSelectorProps) {
    const {data} = useUsers(props.schoolId);
    const [users, setUsers] = useState<User[]>([]);
    const onChangeUser = (newUsers: User[]) => {
        if (props.onChange) {
            props.onChange(newUsers.map(user => user.ruuid));
        }
    };

    useEffect(() => {
        const newUsers = data?.data.filter(user => props.selectedUsers.includes(user.ruuid));
        setUsers(newUsers || []);
    }, [props.selectedUsers, data]);

    return (
        <SelectWrapper
            getOptionLabel={ (user: User) => user.name }
            getOptionValue={ (user: User) => user.ruuid }
            isClearable={true}
            isMulti={true}
            isDisabled={props.isDisabled}
            placeholder="Users"
            onChange={onChangeUser}
            value={users}
            options={data?.data} />
    );
}